export default __webpack_public_path__ + "static/media/moon.b80c8285.svg";